import { ASSET_PATHS } from '../../utils/assetPath';

import './GenericFileIcon.css';

interface GenericFileIconProps {
  /**
   * Additional CSS class name
   */
  className?: string;
  /**
   * Icon size in pixels
   */
  size?: number;
  /**
   * Accessible label for the icon
   */
  ariaLabel?: string;
}

function GenericFileIcon({ className = '', size = 32, ariaLabel = 'File' }: GenericFileIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`generic-file-icon ${className}`}
      height={size}
      src={ASSET_PATHS.GENERIC_FILE_ICON}
      width={size}
    />
  );
}

export default GenericFileIcon;
